// @tennis-matches/services/trainerstunden/billing-statement-document-month
// Kalendermonat der Rechnung (Erstellung), nicht Leistungszeitraum (period_month).

function __asStr(x) {
  return String(x ?? "").trim();
}

function __ymFromIso(iso) {
  const s = __asStr(iso);
  if (!s) return "";
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  return `${y}-${m}`;
}

/**
 * Monat der Rechnung (Rechnungszeitraum): Kalendermonat von `sent_at` (Rechnungsdatum),
 * sonst `created_at` bei noch nicht versendeten Entwürfen.
 * `period_month` ist der Leistungszeitraum und wird hier nicht verwendet.
 *
 * @param {Record<string, unknown>|null|undefined} statement
 * @returns {string} `YYYY-MM` oder leer
 */
export function resolveBillingStatementDocumentMonth(statement) {
  const st = statement && typeof statement === "object" ? statement : {};
  const fromSent = __ymFromIso(st.sent_at ?? st.sentAt);
  if (fromSent) return fromSent;
  const fromCreated = __ymFromIso(st.created_at ?? st.createdAt);
  if (fromCreated) return fromCreated;
  return "";
}

/**
 * Abrechnungs-UI-Monat (Kalendermonat der Rechnungserstellung), nicht Leistungszeitraum.
 *
 * @param {Record<string, unknown>|null|undefined} statement
 * @param {string} reportMonthYm `YYYY-MM`
 */
export function billingStatementMatchesDocumentMonth(statement, reportMonthYm) {
  const cap = __asStr(reportMonthYm);
  if (!cap) return false;
  return resolveBillingStatementDocumentMonth(statement) === cap;
}
